import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#A8AD00",
      200: "#A8AD00",
      300: "#A8AD00",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#A8AD00",
      500: "#A8AD00",
      600: "#A8AD00"
    },
    secondary: {
      100: "#D5E1AB",
      200: "#54301A",
      300: "#A2402A"
    },
    background: {
      100: "#F3F4EA",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#D7D2CB"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#C6653B",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    calendarCtaBorderRadius: 8,
    viewMenuHover: "#A2402A",
    outletLocationRestText: "#A2402A",
    orderOnlineHomeButton: "#A2402A",
    circularAddBtn: "#A8AD00",
    locationListBtn: "#A2402A",
    errorModalHeaderBg: "#F3F4EA",
    startBgColor: "#F3F4EA",
    secondary200Mobile: "#54301A",
    profileHeaderBackground: "#A8AD00",
    locationTopTabColor: "#A2402A",
    waitlistRestaurantInfoBoxText: "#54301A",
    specialInstArrowColor: "black",
    menuItemCardBg: "#F3F4EA",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    menuItemCardBorder: "transparent",
    selectedMenuCategoryBorder: "#A2402A",
    themeErrorColor: "#F3D8DA",
    themeErrorTextColor: "#AF272F",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    listItemDivider: "#D6D6D6",
    categoryBoxDivider: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    themeSectionTextDark: "#8A8A8A",
    grey300: "#303030",
    infoLinkColor: "#A2402A",
    backLinkColor: "#D38232",
    themeTextColor: "#020001",
    legalDesclaimerText: "#020001",
    themeGrey: "#606060",
    headerBackground: "white",
    themeDarkGrey: "#2E2A26",
    orderSettingsDateTimeChoiceColor: "#54301A",
    selectedOptionBorderColor: "#54301A",
    notSelectedOptionBorderColor: "#D6D6D6",
    menuDetailsMobileHeaderText: "#A2402A",
    configOptionsAccordionBackground: "#54301A",
    hStackArrowsColor: "#54301A",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#2A2C25",
    categoryHeaderSeparator: "#EAEAEA",
    btnHoverColor: "#7A301F",
    menuListTooltipBg: "#54301A",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#3f3f46",
    menuDetailTooltipColor: "#d4d4d8",
    menuItemNameColor: "#2A2C25",
    legalTextContainerBg: "#EFEFEF",
    mobileBg: "#FFFFFF",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#FFFFFF",
    menuLinksColor: "#606060",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    deliveryModalNameColor: "#A2402A",
    deliveryAccentColor: "#54301A",
    deliveryTextColor: "#505050",
    deliveryTextColorAccent: "#808080",
    deliveryBorderColor: "#E7E7E7",
    deliveryAccentBorderColor: "#DDDDDD",
    sliderItemColor: "#54301A",
    headerBackgroundTop: "white",
    menuButtonBackgroundColor: "#54301A",
    orderSettingsTextColor: "#A2402A",
    categoriesText: "#A2402A",
    modalCategoriesText: "#A2402A",
    inActiveCategoriesText: "#606060",
    inActiveModalCategoriesText: "#606060",
    mobilePayHeaderBtnBorder: "#A2402A",
    menuItemPriceColor: "#2A2C25",
    menuItemCalorieColor: "#2A2C25",
    scrollToTopColor: "#A2402A",
    menuItemAddButtonColor: "#A2402A ",
    cartNoOfItemsText: "#A2402A",
    cartItemPrice: "#A2402A",
    cartPhoneNumber: "#A2402A",
    cartItemActionBtn: "#A2402A",
    cartHeaderOrderType: "black",
    confirmationModalOptionBg: "#D7D2CB",
    asapOptionBg: "#F3F4EA",
    asapTextColor: "#404040",
    cartHeaderLocationName: "#54301a",
    checkoutButtonBackgroundColor: "#A2402A",
    selectedCarouselItemWithoutImage: "#F3F4EA",
    unselectedCarouselItemWithoutImage: "#ffff",
    itemAddToCartPopupBackground: "#54301A",
    remoteCheckinWaitTimeBg: "#F3F4EA",
    remoteCheckinWaitTimeBorderTwo: "rgba(159, 167, 58, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(159, 167, 58, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(159, 167, 58, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinWaitTimeHeaderText: "#452D20",
    remoteCheckinWaitTimeText: "rgba(159, 167, 58, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#A2402A",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#54301A",
    sliderWithButtonsBackground: "#FFFFFFE5",
    recommendationHeadingColor: "#606060",
    menuDetailAccordionDownArrowColor: "#A8AD00",
    menuDetailAccordionTextColor: "#020001",
    menuDetailsAccordionDetailsBackground: "#00000000",
    // transparent
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#000",
    menuDetailTemparatureSliderLabelColor: "#404040",
    menuDetailItemNameColor: "#2A2C25",
    wcacSecondaryBtnBorder: "#A2402A",
    menuDetailsItemPriceColor: "#2A2C25",
    checkbackSoonBgImgOverlayColor: "#F3F4EA",
    menuDetailsItemDescriptionColor: "#2A2C25",
    menuDetailsItemCaloriesCaolor: "#2A2C25",
    menuDetailsModifiersBorderColor: "#54301A",
    menuDetailsSliderItemBackground: "#EBE9E9",
    menuDetailsBackToMenu: "#D38232",
    menuDetailsSliderHoverColor: "#A2402A",
    loginModalTextColor: "#54301A",
    requiredTextColor: "#A2402A",
    recommendationaInfoTextColor: "#404040",
    legalDisclaimerText: "#020001",
    reoderInfoTextColor: "#404040",
    reorderHeadingsText: "#404040",
    nutritionalHTMLColor: "#020001",
    orderConfirmationTextColor: "#54301A",
    locationListingItemHeading: "#303030",
    locationListingItemHeadingInPage: "#A2402A",
    locationListingItemHeadingMobile: "#A2402A",
    locationListingItemText: "#020001",
    confirmPickupDetailsText: "#2D2926",
    addressTextColor: "#303030",
    itemIsFor: "#606060",
    itemIsForName: "#2A2C25",
    cartItemTitle: "#2A2C25",
    specialInstructions: "#2A2C25",
    cartItemOption: "#2A2C25",
    locationsNear: "black",
    searchResultsName: "#303030",
    locationConfirmationHeadings: "#54301A",
    orderSettingsDesktop: "#020001",
    orderSettingsMobile: "#020001",
    previousOrderItemStatus: "#A8AD00",
    onboardingButtonTextColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    smartRecommendationCardbg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#cb7034",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    accordionDescription: "#A8AD00",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    skuUnavaliableTextColor: "#A2402B",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "#6F3D31",
    linearGradientHeaderLight: "rgba(0,0,0,0)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    lunchIssueModalBody: "#F8F7F6",
    lunchIssueModalSeparator: "#EBE9E9",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F5F7E8",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#A2402A",
    disableJoinWaitlistColor: "#C6C6C6",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#A2402A",
    restaurantInfoAddressTextColor: "#A2402A",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#4D2C42",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#A2402A",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#A2402A",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#4D2C42",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#4D2C42",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#4E311D",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#2A2C25",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationBackground: "#F6F6F6",
    orderConfirmationThanksSubHeaderColor: "#505050",
    restDetailsName: "#54301A",
    orderConfirmationCustomerEmail: "#303030",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "#9A4B32",
    mobileGiftCardGradientSecond: "#BA773E",
    myAccountGiftCardLargeBorderRadius: 26,
    downArrowColor: "#020001",
    categoryNavBgColor: "#F3F4EA",
    mobileMasterCardGradientFirst: "#1D338F",
    mobileMasterCardGradientSecond: "#1D338F",
    mobileMasterCardGradientThird: "#255C95",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#8A8A8A",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BF7D3F",
    waitlistHomeScreenBannerGradientTwo: "#964631",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    orderInfoBg: "#ffff",
    hStackArrowsBg: "#FDFDFDD9",
    specialInstInputBg: "#ffff",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    youMightLikeBannerColor: "#D38232",
    defaultMenuBannerBg: "#F3F4E7",
    defaultMenuTextColor: "black",
    newIndicatorBannerColor: "#C6653B",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "#E9E9E9",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#BF7D3F",
    curbsideHomeScreenBannerGradientTwo: "#964631",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    emptyCartHeaderBgColor: "#D7D2CB",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#F3F4E7",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#993324",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    ninjaIconColor: "#A8AD00",
    orderHistoryDetailsAddress: "#606060",
    orderHistoryDetailsBGColor: "#F6F6F6",
    menuListSkeletonHeaderContainerBackground: "#F8F8F8",
    menuListSkeletonHeaderBackground: "#FFF",
    menuListSkeletonCategoryNavigationBgColor: "#F8F8F8",
    menuListSkeletonTopTabActiveBottomBorderColor: "#A2402A",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#FFFFFF",
    restCallNowCTATextColor: "#FFFFFF",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#FFFFFF",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    plusIconColor: "#A2402A",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    showCreditCard_bottomSheet_BackgroundColor: "#FFFFFF",
    addEditCreditCard_scrollView_backgroundColor: "#F6F6F6",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    cartNumberText: "#ffff",
    bannerDropShadow: "#5F2C2D",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    jwcBgColor: "#F2F4EA",
    jwcOrderAheadImgOverlayShade: "rgba(0, 0, 0, 0)",
    jwxLeaveTheLineCancelBtnBorder: "#A2402A",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    reOrderAddBtnBorder: "#A2402A",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    quantityArrowColor: "#A8AD00",
    textCTAColor: "#A2402A",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    selectedListItem: "#F3F4EA",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    locationListItemBorder: "rgba(0,0,0,.1)",
    allLocationsSelectBgMobile: "#F0FFFF",
    allLocationsSelectBgDesktop: "#F0FFFF",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#ffffff",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#A2402A",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2402A",
    menuCustomisationIsSelectedMobileColor: "#F3F4EA",
    menuCustomisationIsSelectedBorderMobileColor: "#A8AD00",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    selectedNumberOfGuestBorderColor: "#A8AD00",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#a18e82",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#020001",
    categoriesDescriptionColor: "#020001",
    itemUnavailableCardBg: "#F3F4EA",
    itemCardBg: "#F3F4EA",
    itemCardBgLight: "#F3F4EA",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    globalBannerBg: "#532A43",
    // ORDER CONFIRMATION START
    confirmationPrimary: "#A2402A",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#A8AD00",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#CA7C30",
    backgroundE5E5: "#E5E5E5",
    searchKeywordHighlightColor: "#A2402A",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#F6F7F0",
    paymentOptionsBorderColor: "#DCDCDC",
    restDetailsRestInfoTitleColor: "#4E311D",
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    configOptionBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F3F4EA",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#F3F4EA",
    selectedSKUItem: "#F3F4EA",
    nonSelectedSkuItem: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "#F3F4EA",
    nonExpandedAccordionBackground: "#F3F4EA",
    selectedDescriptionText: "#020001",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#D30000",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    carouselBorderColor: "#D6D6D6",
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#4D2C42",
    locaionAndTimeHeaderBg: "#F3F4E7",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#A2402A",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#A2402A",
    orderStatusSectionBg: "#FFFFFF",
    refreshButtonColor: "#A2402A",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    orderStatusSectionBorderColor: "#DCDCDC",
    refreshButtonBg: "#FFFFFF",
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    signInTextColor: "#020001",
    registerTextColor: "#020001",
    recommendationsHeadingColor: "#020001",
    capacityInfoText: "#606060",
    selectedStateColor: "#000000",
    quantityColor: "#020001",
    timeDropdownColor: "#000000",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#000000",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.4)",
    onboardingButtonBackgroundColor: "#A2402A",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F3F4E7",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    checkoutGratuitySliderMinTrackColor: "#A8AD00",
    checkoutGratuitySliderMaxTrackColor: "#D5E1AB",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#A8AD00",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#A2402A",
    homescreenWaitlistButtonTextColor: "#A2402A",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",

    /* Restaurant Details */
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#A2402A",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#A2402A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#EFEEE9",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#532943",
    restaurantDetailsNotSelectedWeekDayTextColor: "#303030",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restaurantTimingWeekDayTextColor: "#4E311D",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    waitlistBannerBg: "#A8AD00",
    waitlistTableHeaderBg: "#F8F8F8",
    waitlistBottomBackground: "#F3F4EA",
    selectedWaitlistRow: "#F3F4EA",
    waitlistFooterBorderTop: "#DDDDDD",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    howItWorksBannerBg: "#9FA73A",
    howItWorksHeaderBg: "#F3EFEB",
    waitlistDisclaimer: "#231815",
    fwlvMiddleCtaBackground: "#BABD9E",
    //Menu search
    suggestedSearchTextColor: "#404040",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#A8AD00",
    searchBarBorderColor: "#D6D6D6",
    searchItemCardTextColor: "#505050",
    searchCardCategorySlugColor: "grey",
    menuSearchModalDivider: "#ABABAB",
    searchModalBackgroundColor: "white",
    menuSearchBarContainerBg: "#FFFFFF",
    // statuses colours:
    highWait: "#CA7C30",
    lowWait: "#A8AD00",
    waitNotAvailable: "#BDBDBD",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    partySizeBgColor: "#A8AD00",
    partySizeBorderColor: "white",
    recentOrdersListItemPrice: "#B31900",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    // keyboard done button:
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    paymentOrderTotalTextColor: "#000000",
    profileHeaderLinearGradientStartColor: "#A8AD00",
    profileHeaderLinearGradientEndColor: "#A8AD00",
    profileAddCardButtonText: "#FFFFFF",
    mobilePayConfirmationScreenBlockBG: "#EEF4E9",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#DDC274",
    reservationSelectedCTABGColor: "#EDDFCB",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    joinWaitlistBackgrouondColor: "#F6F6F6",
    joinWaitlistFormBgColor: "#FFFFFF",
    joinWaitlistFormBorder: "#DEDEDE",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#000000",
    orderTotalTextColor: "#54301A",
    orderTotalPriceColor: "#54301A",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#F3F4EA",
    jwcArrowColor: "#4E311D",
    breadSticksArrowColor: "#54301A",
    waitlistStatusScreenBg: "#F3F4EA",
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#A2402A",
    waitlistVisibilityModalBg: "#000000B2",
    imageStackBorderColor: "#FFFFFF",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#D6DCD2",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    waitlistTableRowSeperator: "#F6F6F6",
    waitlistTableInfoBg: "#452D20",
    waitlistTableInfoText: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.7)",
    homescreenLocationTagBorderColor: "#827070",
    homescreenLocationTextColor: "#54301A",
    homeScreenAlertBackgroundGradientOne: "#BF7D3F",
    homeScreenAlertBackgroundGradientTwo: "#964631",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#A2402A",
    locationSearchActive3Tab: "#54301A",
    locationSearchActive3TabTextColor: "#FFFFFF",
    locationSearchInActive3TabTextColor: "#606060",
    locationSearch3Tabs: "#E5E4E0",
    searchBarBackgroundForThreeTabs: "#F2F0F0",
    searchThisAreaBg: "#A2402A",
    locationSearchInActiveTab: "#808080",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#A2402A",
    callRestLsText: "#A8AD00",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#DEDEDE",
    locationSearchTabBgColor: "transparent",
    lsAllLocationsSelectBorder: "#D6D6D6",
    locationSearchAddressColor: "#020001",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#A2402A",
    hoursInfoAccordionTitle: "#532943",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#A2402A",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#A2402A",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#A2402A",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#54301A",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#54301A",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#D7D2CB",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F3F4EA",
    criticalModeBg: "#fafafa",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#532A43",
    reorderAddItemBg: "#A2402A",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#54301A",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#54301A",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#54301A",
    selectedOrderTypeTextColor: "#54301A",
    reservationsLocationCardBg: "#FFFFFF",
    reservationDetailsCTABg: "#FFFFFF",
    reservationAvailableTimeSlotBg: "transparent",
    reservationTimeSlotsItemInactiveBg: "#D8DCE0",
    reservationsSpecialRequestBg: "transparent",
    reservationsConfirmationDetailsBg: "#FFFFFF",
    reservationHeaderTitleColor: "#404040",
    reservationDOBBgColor: "transparent",
    reservationsCardBg: "#fff",
    modalHeaderColor: "#fff",
    modalHeaderTextColor: "#404040",
    mobileCalendarTextColor: "#A2402A",
    gcBalanceRefreshBorderTextColor: "#A2402A",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    smartRecommendationModalCloseIconColor: "#737373",
    noReservationBorder: "transparent",
    networkIndicatorColor: "black",
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000",
    confirmationModalBorderRadius: 4,
    reservationPopupBgColor: "#FFFFFF",
    desktopTopTabsBG: "transparent",
    menuSearchModalCloseIconColor: "black",
    menuSearchInputBorder: "primary.100",
    menuSearchResultContainerBG: "#fff",
    pdRequestFormBG: "#fff",

    /** My Account */
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenMobileBackgroundColor: "#F6F6F6",
    myAccountScreenWebBackgroundColor: "#fff",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    myAccountBgImageOverlay: "#F7F8E8",
    myAccountBgColor: "#F7F8E8",
    myAccountCardBackgroundActive: "#F7F8E8",
    myAccountChangeFieldModalBg: "white",
    myAccountEditProfileScrollViewBg: "white",
    myAccountDOBYearBgColor: "transparent",
    myAccountDOBMonthBgColor: "transparent",
    myAccountDOBTextColor: "#A2402A",
    myAccountCalendarCtaBorderRadius: 6,
    editProfileFullBottomButtonBackgroundColor: "white",
    orderHistoryFullBottomButtonBackgroundColor: "white",
    orderHistoryDetailsHeaderModalBackgroundColor: "white",
    pdInputDataTextColor: "#000",
    menuListingContainerBG: "#fff",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "#fff",
    editProfile_modalHeaderBackgroundColor: "#FFFFFF",
    editProfile_modalBodyBackgroundColor: "#F6F6F6",
    confirmationModalCTABackgroundColor: "#A2402A",
    giftCardLargeBody_BackgroundColor: "#FFFFFF",
    giftCardLargeBody_webModalBackgroundColor: "#F6F6F6",
    giftCardLargeHeader_BackgroundColor: "#FFFFFF",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    myAccountMenuItemActiveTextColor: "#A2402A",
    myAccountMenuItemInActiveTextColor: "#303030",

    /** My Account */
    reservationsTimePickerBg: "#FFF",
    eClubHoverActiveColor: "#F3F4EA",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#F3F4E9",
    eClub_confirmation_background_color: "#F2F4EA",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F2F4EA",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    joinEclubDOBTextColor: "#A2402A",
    EClubInputErrorColor: "#f00",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    joinEclubContainerBgColor: "#F2F4EA",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#FFFFFF",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#FFFFFF",
    orderHistoryModalHeaderTextColor: "#404040",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    gcBalanceRefreshBGColor: "white",
    EclubFormInputPlaceholderTextColor: "#C0C0C0",
    myAccountSkipConfirmationCTA: "#CA7C30",
    paymentOptions_giftCard_balanceAmountColor: "#000000",
    menuItemcardVerticalImageBorderRadius: "xl",
    EclubDOBBottomBorderColor: "#606060",
    globalMessageBannerPadding: 1,
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#F3F4EA",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    orderDetailsCartItemPrice: "#000000"
  },
  components: {
    Pressable: {
      variants: {
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          pt: 2,
          pb: "6px",
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 50
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderRadius: 5,
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            borderRadius: 8,
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref4) {
          var btnPadding = _ref4.btnPadding,
              disabled = _ref4.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            borderRadius: 8,
            paddingY: btnPadding ? btnPadding : 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        // JOIN WAITLIST START
        joinWaitlist_Guests_Number_Container: function joinWaitlist_Guests_Number_Container(_ref5) {
          var selected = _ref5.selected;
          return {
            shadow: selected ? 8 : "none",
            width: {
              base: "44px",
              lg: "56px"
            },
            height: {
              base: "40px",
              lg: "51px"
            },
            bg: selected ? "secondary.300" : "white",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 6,
            borderWidth: 1,
            borderColor: selected ? "secondary.300" : "#DEDEDE"
          };
        },
        joinWaitlist_CTA_Cancel_Button: function joinWaitlist_CTA_Cancel_Button() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 24
            },
            borderWidth: 1,
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        joinWaitlist_CTA_JW_Button: function joinWaitlist_CTA_JW_Button(_ref6) {
          var disabled = _ref6.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            paddingY: 4,
            px: {
              lg: 20
            },
            borderWidth: 1,
            borderColor: disabled ? "#DADADA" : "#A2402A",
            bgColor: disabled ? "#DADADA" : "#A2402A"
          };
        },
        // JOIN WAITLIST END
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        criticalModeOrderCTA: {
          backgroundColor: "#A2402A",
          borderRadius: "8px"
        },
        borderRadiusValue: function borderRadiusValue(_ref7) {
          var radiusValue = _ref7.radiusValue,
              topRadiusValue = _ref7.topRadiusValue,
              bottomRadiusValue = _ref7.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        },
        // My Account starts
        myAccount_edit_fields_sheet_title_container: {
          bg: "white",
          width: "100%"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_infoList_changeOperation_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          shadow: 17,
          py: 5,
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 8
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: {
          my: 1,
          borderRadius: 8,
          _web: {
            my: 0
          },
          flex: 1,
          ml: 2,
          backgroundColor: "secondary.300",
          border: 1.5,
          borderColor: "secondary.300"
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 8,
          py: 3,
          px: 4
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 8,
          py: 3,
          px: 4
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "secondary.300",
          px: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          borderRadius: 10
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300",
          borderRadius: 8
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref8) {
          var isActive = _ref8.isActive;
          return {
            borderRadius: 8,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "#FFFFFF",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },
        // My Account ends
        eClubStickySignUpDesktopPressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          ml: 3,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 10,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        myAccount_paymentOptions_checkBalanceCTA: {
          marginY: 1,
          border: 1.5,
          borderColor: "#A2402A",
          borderRadius: 8,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        }
      }
    },
    Button: {
      baseStyle: {
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        }
      },
      variants: {
        solid: {
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "secondary.300"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        remoteCheckinBodyBtn: {
          mt: 3,
          bg: "#A2402A",
          _web: {
            width: {
              base: "80%",
              sm: "80%",
              md: "100%"
            }
          },
          pt: 4,
          pb: 4
        },
        camAccessBtn: {
          bg: "#A2402A",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          borderRadius: 4,
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          borderRadius: 4,
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "secondary.300"
          }
        },
        wcacSecondaryBtn: {
          bg: "white",
          _hover: {
            bg: "background.100"
          },
          _pressed: {
            bg: "background.100"
          },
          border: 1,
          borderColor: "#A2402A",
          mr: 3,
          _text: {
            px: 4,
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A",
            textTransform: "uppercase"
          }
        },
        wcacPrimaryBtn: {
          bg: "secondary.300",
          _pressed: {
            bg: "primary.100"
          },
          _hover: {
            bg: "primary.100"
          },
          _text: {
            px: 2,
            fontSize: 16,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "secondary.200",
            fontWeight: "400",
            fontStyle: "normal",
            fontSize: "lg",
            lineHeight: 7,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            borderRadius: borderRadiusValue || 0,
            backgroundColor: "secondary.300",
            shadow: 9
          };
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref11) {
          var borderRadiusValue = _ref11.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            }
          };
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 400,
            _ios: {
              fontSize: 13
            },
            _android: {
              fontSize: 13
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase"
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase"
            },
            bg: "secondary.300",
            border: 1,
            borderColor: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "secondary.200",
            fontStyle: "normal",
            lineHeight: 7,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        menuButton: function menuButton(_ref12) {
          var isActive = _ref12.isActive,
              isMobile = _ref12.isMobile,
              isLongText = _ref12.isLongText;
          return {
            ml: isLongText && isMobile && 5,
            px: isMobile ? 6 : 9,
            _web: {
              borderReadis: "17px",
              pt: "7px",
              width: !isMobile && (isLongText ? "100%" : "117px")
            },
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            width: !isMobile && (isLongText ? "100%" : 32),
            height: {
              base: 8,
              md: 9
            },
            borderReadis: 4,
            rounded: "full",
            pt: 2,
            pb: 1,
            _text: {
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "300",
              fontSize: isMobile ? "xs" : "sm",
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px"
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase",
              fontFamily: "heading"
            }
          };
        },
        pillButton: function pillButton(_ref13) {
          var isActive = _ref13.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "secondary.200"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref14) {
          var isUnavailable = _ref14.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "#A2402A",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "#7A301F"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "#7A301F"
            },
            _text: {
              fontWeight: "700"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "4px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 8
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#A2402A",
          borderWidth: 1
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: {
                base: "#A2402A",
                lg: "#54301A"
              },
              fontWeight: 400
            },
            borderColor: {
              base: "#A2402A",
              lg: "#54301A"
            },
            borderRadius: {
              base: "6px",
              lg: "2px"
            },
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _hover: {
              backgroundColor: "white"
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            border: 1
          };
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        preorderDineIn: {
          backgroundColor: "#A2402A"
        },
        // LS page
        locationListItemButtonBorderRadius: 6,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 6,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        defaultBannerBtn: {
          _web: {
            minW: 134,
            px: 4,
            py: 2
          },
          _ios: {
            px: 2,
            py: 2,
            mt: 0.5
          },
          _android: {
            px: 2,
            py: 2,
            mt: 0.5
          },
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "primary.200",
          bg: "secondary.300"
        },
        borderRadiusValue: function borderRadiusValue(_ref15) {
          var radiusValue = _ref15.radiusValue,
              topRadiusValue = _ref15.topRadiusValue,
              bottomRadiusValue = _ref15.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        viewNutritionalVariant: {
          pb: 0,
          mb: 0
        },
        confirmBtnBorderRadius: {
          borderRadius: 8
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "secondary.300",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "secondary.300"
          }
        },
        confirmAndAddToCartButton: {
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "secondary.300"
          }
        },
        ErrorDialogOKButton: {
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "secondary.300"
          }
        },
        editProfileFullBottomButton: {},
        orderHistoryReorderFullBottomButton: {},
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300"
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300"
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: {
            base: "md",
            md: "lg"
          },
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "og_brotherregular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 8
        },
        borderRadiusValue: function borderRadiusValue(_ref16) {
          var radiusValue = _ref16.radiusValue,
              topRadiusValue = _ref16.topRadiusValue,
              bottomRadiusValue = _ref16.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        myAccountInputForm: {
          fontFamily: "og_brotherregular"
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref17) {
          var isMandatory = _ref17.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "10"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        },
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%"
          },
          _android: {
            width: "100%"
          }
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref18) {
          var radiusValue = _ref18.radiusValue,
              topRadiusValue = _ref18.topRadiusValue,
              bottomRadiusValue = _ref18.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        editFieldsConfirmationModal: {
          borderRadius: 12,
          p: 12
        },
        editFieldsSuccessModal: {
          borderRadius: 12,
          p: 12,
          maxWidth: {
            md: "588"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 12,
          bgColor: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          }
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 12
        }
      }
    },
    ModalBody: {
      variants: {
        errorDialogModalBody: {
          fontFamily: "og_brotherlight"
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          borderRadius: 12,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 12,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref19) {
          var isMandatory = _ref19.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref20) {
          var isMandatory = _ref20.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref21) {
          var isDefaultExpanded = _ref21.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "xl"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 12
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Container: function joinWaitlist_StaticMap_Container() {
          return {
            flexDirection: {
              md: "row"
            },
            m: 5,
            borderRadius: 16,
            overflow: "hidden",
            shadow: 10
          };
        },
        // JOIN WAITLIST END
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        }
      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 6,
          w: 0.4
        },
        //Restaurants Details
        restaurantDetails_Amenities_Divider: {
          mx: 3.5,
          height: 3,
          backgroundColor: {
            base: "restDetailsAmenitiesDividerMobileColor",
            lg: "restDetailsAmenitiesDividerColor"
          }
        },
        restaurantDetails_CurrentStatus_Mob_Divider: {
          alignSelf: "flex-start",
          backgroundColor: "restaurantDetailsCurrentStatusAndWaitlistDividerColor",
          width: "100%"
        },
        restaurantDetails_RestInfo_ShareButton_Divider: {
          bgColor: "restaurantNumberAndDistanceDividerColor",
          orientation: "vertical",
          mx: 5
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4,
          bgColor: "restaurantTimingsDividerColor"
        },
        menu_detail_divider: {
          bgColor: "white",
          height: "40px",
          mb: 0
        }
      }
    },
    Text: {
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        breadsticksCheckoutBannerNumberText: {
          fontStyle: "italic",
          fontWeight: 700,
          fontSize: 12,
          color: "#606060"
        },
        breadsticksCheckoutBannerText: {
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: 12,
          color: "#606060"
        },
        breadSticksTotalText: {
          fontSize: 16,
          fontWeight: 500,
          textTransform: "capitalize"
        },
        breadSticksTableHeader: {
          fontSize: 14,
          color: "#606060",
          textTransform: "capitalize"
        },
        breadSticksTableContent: {
          fontSize: 14,
          color: "#2A2C25"
        },
        breadSticksBanner: {
          color: "#54301A",
          fontSize: 14,
          fontWeight: 400,
          ml: 16
        },
        breadSticksBannerNumber: {
          color: "#54301A",
          fontSize: 16,
          fontWeight: 500
        },
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#A2402A"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        OrderInfoBannerCartIconText: {
          pt: 1
        },
        LoginHeaderText: {
          pt: 1
        },
        checkoutTopLabelText: {
          pt: 1
        },
        emailReceiptText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary200Mobile"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        refreshErrorWaitlist: {
          fontSize: 14,
          pt: 1
        },
        waitlistRestaurantInfoBoxTitle: {
          fontSize: 15,
          fontWeight: 400,
          color: "waitlistRestaurantInfoBoxText"
        },
        waitlistRestaurantInfoBoxBody: {
          lineHeight: 18,
          fontSize: 14,
          fontWeight: 300,
          color: "waitlistRestaurantInfoBoxText"
        },
        wcacPrimaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        wcacSecondaryBtnText: {
          fontSize: 16,
          fontWeight: 400,
          color: "#A2402A",
          textTransform: "uppercase"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "#A2402A"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#4E311D"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#4E311D"
        },
        jwcRestDetails: {
          color: "#4E311D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#4E311D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: {
            base: "#A2402A",
            lg: "white"
          },
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#A2402A",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: {
            base: 14,
            lg: 18
          },
          color: {
            base: "#303030",
            lg: "#2A2C25"
          },
          lineHeight: 6
        },
        jwcWaitTimeVaryMobile: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        jwcPartySizeNumber: {
          fontWeight: "500",
          fontSize: {
            base: 14,
            lg: 18
          },
          color: "#4E311D"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: {
            base: 14,
            lg: 18
          },
          color: "#4E311D"
        },
        jwcTitle: {
          textAlign: "center",
          mt: 6,
          fontSize: 24,
          fontWeight: 500,
          color: "#4E311D"
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#4E311D",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        //JWC ENDS
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          lineHeight: 4,
          textAlign: "center"
        },
        fwlvButtonText: {
          fontSize: 14,
          color: "#4E311D",
          textAlign: "center",
          marginTop: 2,
          textTransform: "capitalize"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 400,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: {
            base: 20,
            md: 22
          },
          lineHeight: 22,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 3,
          px: 4,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          color: "#A2402A"
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinTitle: {
          color: "#4E311D",
          fontSize: 24,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          fontWeight: 500,
          textAlign: "center"
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3",
          fontWeight: 500
        },
        remoteCheckinWaitTimePartySizePrefix: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinBodyOrderAheadText: {
          fontSize: "22px",
          color: "white"
        },
        enableLocationText: {
          fontWeight: 300,
          fontSize: 15,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#452D20"
        },
        checkinSuccessModalHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 16,
          textAlign: "center",
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          color: "#452D20"
        },
        checkinSuccessModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 14,
          px: 4,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 17,
          color: "#303030"
        },
        checkinErrorModalHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 18,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 6,
          color: "#452D20"
        },
        clearedWaitlistBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 16,
          px: 7,
          lineHeight: 22,
          color: "#231815"
        },
        clearedWaitlistHeaderText: {
          fontFamily: "body",
          fontWeight: 400,
          fontSize: 24,
          lineHeight: 27,
          color: "#452D20"
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        checkinErrorModalBodyText: {
          fontFamily: "body",
          fontWeight: 300,
          fontSize: 15,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5",
          lineHeight: 5,
          color: "#303030"
        },
        remoteCheckinBodyText: {
          fontSize: 16,
          fontWeight: 400,
          color: "white"
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 300,
          marginY: 11,
          marginTop: 13,
          marginX: 5
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        categoryText: function categoryText(_ref22) {
          var isActive = _ref22.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "24px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          fontSize: "xl"
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        menuItemNameWeight: function menuItemNameWeight(_ref23) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref23.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 400,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: [18, 18, 28],
            fontWeight: 400,
            fontFamily: "headingSecondary"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            fontSize: [16, 16, 22],
            fontFamily: "headingSecondary",
            fontWeight: 400
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: ["md", "md", "xl"]
          };
        },
        locationText: {
          color: "secondary.200",
          fontSize: "xs",
          fontFamily: "body"
        },
        phoneNumberText: {
          color: "secondary.200",
          fontSize: "xs",
          fontFamily: "body"
        },
        btnText: {
          color: "secondary.200",
          fontFamily: "heading"
        },
        headerText: {
          color: "secondary.200"
        },
        cartItemCancelText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 400
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 400,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: "md",
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref24) {
          var isMandatory = _ref24.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "24"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 5,
              md: 7
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref25) {
          var isMandatory = _ref25.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "24"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: -0.3,
            lineHeight: {
              base: 5,
              md: 7
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref26) {
          var isMobile = _ref26.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: -0.3,
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: -0.3,
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: -0.3
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref27) {
          var isMandatory = _ref27.isMandatory,
              isDefaultExpanded = _ref27.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "xs"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 300,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: -0.3,
            color: isDefaultExpanded ? "white" : isMandatory ? "white" : "themeTextColor"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "#721C24",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#721C24",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            _web: {
              mb: {
                base: "5px",
                md: "10px"
              }
            },
            mb: {
              base: 1,
              md: 2
            },
            fontSize: ["xl", "xl", "4xl"],
            fontWeight: 500
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        nutritinalInfo: function nutritinalInfo() {
          return {
            fontSize: ["md", "md", "lg"],
            fontWeight: 400
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            fontSize: "xl",
            fontWeight: 600,
            fontFamily: "headingSecondary"
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: 5
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 300,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 12,
            fontWeight: 300,
            color: "secondary.300"
          };
        },
        cartItemMenuName: function cartItemMenuName(_ref28) {
          var inOrderDetails = _ref28.inOrderDetails;
          return {
            fontSize: inOrderDetails ? {
              base: 14,
              lg: 16
            } : 17,
            lineHeight: 5,
            _web: {
              letterSpacing: "-0.3px",
              width: {
                base: inOrderDetails ? "100%" : "164px"
              }
            },
            letterSpacing: -0.3,
            width: {
              base: 40
            },
            fontWeight: inOrderDetails ? 800 : 400,
            color: "menuItemNameColor"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xxs"
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName(_ref29) {
          var inOrderDetails = _ref29.inOrderDetails;
          return {
            fontSize: inOrderDetails ? 12 : 15,
            lineHeight: 5,
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: -0.3,
            width: 40,
            noOfLines: 3,
            color: "menuItemNameColor"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontSize: 14,
            lineHeight: 16
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              }
            },
            // fontSize: { base: 3, md: 4 },
            fontWeight: "400"
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 3
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 16
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 400,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: [12, 12, 14],
            fontWeight: 400,
            pr: 2
          };
        },
        mobileOrderDetailsHeader: function mobileOrderDetailsHeader() {
          return {
            fontWeight: 400,
            fontSize: 18
          };
        },
        mobileOrderDetailsStatic: function mobileOrderDetailsStatic() {
          return {
            fontWeight: 300,
            fontSize: 12
          };
        },
        mobileOrderDetailsInput: function mobileOrderDetailsInput() {
          return {
            fontWeight: 400,
            fontSize: 16
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderOrderType",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderLocationName",
            textDecoration: "underline",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 300,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600
        },
        allLocationsSelectText: {
          fontSize: 20,
          fontWeight: 400
        },
        allLocationsText: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref30) {
          var addButtonText = _ref30.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            _web: {
              fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : "md"
            },
            _ios: {
              fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 13 : "md",
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 13 : "md",
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0
          };
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 2
        },
        cartItemRemoveText: {
          fontSize: "xs",
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 400
        },
        pdfMenuButtonText: {
          mt: 1,
          _web: {
            mt: 0
          }
        },
        OnboardingScreenTitleTextColor: {
          color: "secondary200Mobile",
          fontWeight: "500"
        },
        locationListRestaurantName: {
          fontWeight: 400,
          fontSize: "sm",
          lineHeight: 16,
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          },
          textAlign: "left"
        },
        locationListRestaurantDetails: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          _web: {
            width: "70%",
            lineHeight: "18px"
          },
          fontWeight: 300,
          lineHeight: 4
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupRestNameTitle: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // eslint-disable-next-line @typescript-eslint/
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentLight",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#4E311D",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: {
              base: "400",
              lg: "700"
            }
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "orderConfirmationCustomerEmail",
            fontWeight: "400"
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#2A2C25",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "300"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#282C25",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "800"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: "400",
              lg: "800"
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "confirmationAccentDark"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#4D2C42",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "black",
            fontWeight: 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "#303030",
            fontWeight: 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            color: "black",
            fontSize: {
              base: 16,
              lg: 18
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            }
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSvgCenteredText: function confirmationSvgCenteredText() {
          return {
            pt: {
              lg: "2px"
            }
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "4px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "18px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: 15,
            _web: {
              lineHeight: 6,
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              },
              fontSize: {
                base: 14,
                lg: 16
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "restaurantInfoAddressTextColor"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref31) {
          var customMarginHorizontal = _ref31.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: [16],
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: "#606060"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#54301A"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#54301A"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            //font specific styles
            color: "#606060",
            pt: "4px",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref32) {
          var disabled = _ref32.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 20,
              lg: 30
            },
            // mb: 4,
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#606060",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: "18px",
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "200",
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            color: "amenitiesActionButtonsColor",
            textAlign: "center",
            _ios: {
              textTransform: "uppercase"
            },
            _android: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: "20px",
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "12",
            lg: "16"
          },
          color: "#606060"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "white",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "16px",
            color: "orderFromHereButtonTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "restaurantTimingWeekDayTextColor",
            fontSize: {
              base: "10",
              lg: "12"
            },
            position: "absolute"
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },

        /* Restaurant Details End */
        waitlistLocationName: {
          fontSize: 16,
          fontWeight: 400,
          color: "#4E311D"
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#A2402A",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 200,
          color: "white"
        },
        waitlistBannerHeaderText: {
          fontSize: 15,
          fontWeight: 400,
          color: "white"
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 16,
            md: 16,
            lg: 18
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 300,
          my: 4,
          textAlign: "center",
          letterSpacing: 1
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        myLocationsLoginText: {
          fontWeight: 600,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        waitlistOrder: {
          color: "#A2402A",
          textTransform: "uppercase",
          fontWeight: 400,
          fontSize: 12
        },
        waitlistDisclaimer: {
          fontWeight: 200
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 1
            },
            _android: {
              py: 1
            },
            marginBottom: 1.5,
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "secondary.200",
            fontWeight: 300,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            _ios: {
              fontSize: 14
            },
            _android: {
              fontSize: 14
            },
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#54301A",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400,
          _web: {
            marginTop: 1
          }
        },
        howItWorksHeader: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 4
        },
        howItWorksBanner: {
          fontWeight: 300,
          lineHeight: 5
        },
        howItWorksStepsNumber: {
          fontWeight: 500,
          color: "#2C2A26",
          fontSize: 14
        },
        howItWorksActionButton: {
          fontSize: 16,
          fontWeight: 600,
          my: 4.5
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        howItWorksSteps: {
          fontWeight: 400,
          color: "#2C2A26",
          fontSize: 14
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            _ios: {
              fontSize: 14
            },
            _android: {
              fontSize: 14
            },
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            _ios: {
              fontSize: 14
            },
            _android: {
              fontSize: 14
            },
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "themeTextColor",
            fontWeight: 400
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "menuItemNameColor",
            fontWeight: 400
          };
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_RestName: function joinWaitlist_StaticMap_RestName() {
          return {
            fontSize: {
              base: 12,
              md: 16
            },
            lineHeight: 4,
            fontWeight: 400,
            color: "grey300",
            mb: 1,
            w: {
              md: "100%"
            },
            _ios: {
              maxW: 300
            },
            _android: {
              maxW: 300
            }
          };
        },
        joinWaitlist_StaticMap_RestAddress: function joinWaitlist_StaticMap_RestAddress() {
          return {
            fontSize: 12,
            fontWeight: 300,
            color: "themeGrey",
            lineHeight: 4
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Web: function joinWaitlist_StaticMap_ChangeLocation_Web() {
          return {
            fontSize: 12,
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            mt: 4,
            _ios: {
              textTransform: "uppercase"
            },
            _android: {
              textTransform: "uppercase"
            }
          };
        },
        joinWaitlist_StaticMap_ChangeLocation_Mobile: function joinWaitlist_StaticMap_ChangeLocation_Mobile() {
          return {
            color: "secondary.300",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 14,
            _ios: {
              fontSize: 12,
              textTransform: "uppercase"
            },
            _android: {
              fontSize: 12,
              textTransform: "uppercase"
            }
          };
        },
        joinWaitlist_Guests_Title: function joinWaitlist_Guests_Title() {
          return {
            lineHeight: 4,
            letterSpacing: -0.3,
            fontWeight: 400,
            color: "grey300",
            fontSize: {
              base: "14",
              lg: "16"
            },
            textAlign: "center",
            pl: 4,
            mt: 2,
            mb: 2
          };
        },
        joinWaitlist_Guests_Number: function joinWaitlist_Guests_Number(_ref33) {
          var selected = _ref33.selected;
          return {
            fontSize: {
              base: 14,
              lg: 20
            },
            letterSpacing: -0.3,
            fontWeight: {
              base: "400",
              lg: "300"
            },
            color: selected ? "white" : "themeGrey"
          };
        },
        joinWaitlist_Guests_Note: function joinWaitlist_Guests_Note() {
          return {
            color: "themeGrey",
            fontSize: {
              base: "10",
              lg: "12"
            },
            lineHeight: 4,
            fontWeight: 400,
            letterSpacing: -0.3
          };
        },
        joinWaitlist_Guests_Note_Wrapper: function joinWaitlist_Guests_Note_Wrapper() {
          return {
            maxW: 300,
            textAlign: "center",
            mx: "auto",
            px: 4,
            mb: 2
          };
        },
        joinWaitlist_Guests_PhoneNumber: function joinWaitlist_Guests_PhoneNumber() {
          return {
            fontSize: 10,
            lineHeight: 4,
            letterSpacing: -0.3,
            color: "secondary.300",
            _web: {
              flexDirection: "row",
              whiteSpace: "nowrap"
            }
          };
        },
        joinWaitlist_CTA_Cancel_Button_Text: function joinWaitlist_CTA_Cancel_Button_Text() {
          return {
            fontSize: {
              base: "16",
              lg: "20"
            },
            color: "amenitiesActionButtonsColor",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_CTA_JW_Button_Text: function joinWaitlist_CTA_JW_Button_Text() {
          return {
            fontSize: {
              base: "16px",
              lg: "20px"
            },
            color: "white",
            textTransform: "uppercase",
            _web: {
              textTransform: "capitalize"
            }
          };
        },
        joinWaitlist_EstTime_Title: function joinWaitlist_EstTime_Title() {
          return {
            color: "#4E311D",
            fontSize: 14,
            letterSpacing: -0.3,
            textAlign: "center"
          };
        },
        joinWaitlist_EstTime_Unvailable_Text: function joinWaitlist_EstTime_Unvailable_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_NoWait_Text: function joinWaitlist_EstTime_NoWait_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Text: function joinWaitlist_EstTime_Available_Text() {
          return {
            fontWeight: "300",
            color: "#303030",
            fontSize: {
              base: "14",
              lg: "16"
            },
            _ios: {
              fontSize: {
                base: "14"
              }
            },
            _android: {
              fontSize: {
                base: "14"
              }
            },
            letterSpacing: -0.3,
            textAlign: "center",
            lineHeight: 5,
            maxW: {
              lg: 400
            }
          };
        },
        joinWaitlist_EstTime_Available_Time: function joinWaitlist_EstTime_Available_Time() {
          return {
            color: "#54301A",
            fontSize: 32,
            letterSpacing: -0.3,
            textAlign: "center",
            mb: 2
          };
        },
        joinWaitlist_WaitTimeInfo_Text: function joinWaitlist_WaitTimeInfo_Text() {
          return {
            color: "themeGrey",
            fontWeight: 300,
            fontSize: {
              base: "12",
              lg: "13"
            },
            lineHeight: 5,
            letterSpacing: -0.3
          };
        },
        joinWaitlist_Form_Error: function joinWaitlist_Form_Error() {
          return {
            color: "red.400",
            fontWeight: 400,
            fontSize: ["xs"],
            mt: 2
          };
        },
        joinWaitlist_Form_Mobile_Number_Info_Text: function joinWaitlist_Form_Mobile_Number_Info_Text() {
          return {
            color: "#7E7E7E",
            fontWeight: "400",
            fontSize: {
              base: 11,
              lg: 12
            },
            mt: {
              base: "6px",
              lg: 2
            }
          };
        },
        joinWaitlist_Form_Title: function joinWaitlist_Form_Title() {
          return {
            fontSize: {
              base: 16,
              lg: 22
            }
          };
        },
        joinWaitlist_Form_Checkbox: function joinWaitlist_Form_Checkbox() {
          return {
            color: "#606060",
            fontSize: 14,
            lineHeight: 4,
            fontWeight: 300,
            ml: 2,
            mr: 2.5,
            _web: {
              userSelect: "none"
            },
            flexShrink: 1
          };
        },
        joinWaitlist_Form_Filled_Status: function joinWaitlist_Form_Filled_Status() {
          return {
            fontSize: 12,
            color: "#993324"
          };
        },
        joinWaitlist_Form_Filled_PhoneNumber: function joinWaitlist_Form_Filled_PhoneNumber() {
          return {
            fontSize: 14,
            fontWeight: 300
          };
        },
        joinWaitlist_Form_Filled_Email: function joinWaitlist_Form_Filled_Email() {
          return {
            fontSize: 14,
            fontWeight: 300,
            mb: 2
          };
        },
        joinWaitlist_Form_Filled_Name: function joinWaitlist_Form_Filled_Name() {
          return {
            fontSize: 14,
            mb: 2
          };
        },
        joinWaitlist_WineWhileYouWait_Msg: function joinWaitlist_WineWhileYouWait_Msg() {
          return {
            fontWeight: "300",
            fontSize: {
              base: "sm",
              lg: "lg"
            },
            lineHeight: 5,
            maxWidth: "65%",
            flexWrap: "wrap",
            letterSpacing: -0.4,
            flex: 1,
            ml: {
              lg: 8
            },
            color: "#54301A"
          };
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#54301A"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#A2402A"
          };
        },
        joinWaitlist_Header_Title: function joinWaitlist_Header_Title() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "#303030",
            letterSpacing: -0.3
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        // JOIN WAITLIST END
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 24,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        locationSearch_search_current_location_text: function locationSearch_search_current_location_text() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            color: "searchCurrentLocation"
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 400
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 400
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "base",
            fontWeight: "400",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "base",
            fontWeight: "300",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 400,
            height: "60%"
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "#A2402A",
            fontWeight: {
              base: 400
            },
            pt: 2
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref34) {
          var isActive = _ref34.isActive;
          return {
            fontWeight: isActive ? 400 : 300
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "og_brotherlight",
            color: "#2A2C25",
            fontSize: 14
          };
        },
        increaseTextSize: function increaseTextSize(_ref35) {
          var styleSize = _ref35.styleSize;
          return {
            fontSize: styleSize
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountChangeLocationChangeText: {
          color: "#A2402A",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          }
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref36) {
          var prevMonthButtonDisabled = _ref36.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#A2402A",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref37) {
          var nextMonthButtonDisabled = _ref37.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#A2402A",
            textTransform: "capitalize"
          };
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          fontFamily: "og_brotherregular",
          textTransform: "uppercase",
          color: "#4E311D"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          color: "myAccountSubTextColor",
          noOfLines: 1,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "myAccountSubTextColor"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 10,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#A2402A"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "secondary200Mobile"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "12px",
              md: "13px"
            },
            fontWeight: 200,
            color: {
              base: "#606060",
              md: "#303030"
            }
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#737373",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#8E8E8E",
          mt: 3,
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mb: 2
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#8E8E8E",
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mt: 3,
          mb: 2
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "secondary.300"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontSize: 16,
          fontWeight: 300,
          color: "#606060",
          lineHeight: 5,
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "profileAddCardButtonText",
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#A2402A",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3
            }
          },
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 300,
          color: "themeGrey",
          py: 2,
          textAlign: "center",
          mt: 5
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          mb: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4,
          mt: 1
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 3.5,
          marginBottom: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "saveCardAddButtonTextColor",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3
            }
          },
          fontWeight: 300
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          }
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 16,
          fontWeight: 300,
          color: "orderHistoryDetailsText",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "secondary200Mobile"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        // My Account ends
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "secondary.200",
          fontSize: 24,
          width: "70%",
          lineHeight: 8
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "secondary.200",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 200,
          color: "secondary.200",
          fontSize: 14
        },
        eClub_smsText_Primary: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 200,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          fontWeight: 200,
          color: "secondary.300",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "#A2402A",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {};
        },
        quantityText: function quantityText() {
          return {
            fontSize: {
              base: "xs",
              md: "lg"
            },
            fontWeight: 300,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        myAccount_mobileHeader_text: {
          color: "#2A2C25",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "secondary200Mobile"
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 400
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 500,
          textAlign: "center",
          color: "white",
          fontSize: {
            base: 24,
            md: 32
          },
          width: "60%",
          lineHeight: 8
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "white",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1"
        },
        myAccountConfirmationHeadSubText: {
          color: "#808080",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },
        dateTimePickerModalTitle: {
          display: "initial"
        }
      }
    },
    VStack: {
      variants: {
        // actionButtonBoxShadow: {
        // },
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        // JOIN WAITLIST START
        joinWaitlist_Guests_Container: function joinWaitlist_Guests_Container() {
          return {
            py: {
              lg: 2,
              base: 4
            },
            mb: 5,
            mx: 5,
            borderRadius: 16,
            shadow: 10,
            bg: "white",
            space: 3
          };
        },
        joinWaitlist_EstTime_Container: function joinWaitlist_EstTime_Container() {
          return {
            px: 5,
            pt: 5,
            _ios: {
              pt: 2,
              mb: 0
            },
            _android: {
              pt: 2,
              mb: 0
            }
          };
        },
        joinWaitlist_EstTime_Unvailable_Text_Container: function joinWaitlist_EstTime_Unvailable_Text_Container() {
          return {
            alignItems: "center",
            mt: 0,
            mb: 5,
            _ios: {
              mt: 0.5,
              mb: 2
            },
            _android: {
              mt: 0.5,
              mb: 2
            }
          };
        },
        joinWaitlist_WaitTimeInfo_Container: function joinWaitlist_WaitTimeInfo_Container() {
          return {
            bg: "white",
            px: 5,
            py: 5,
            mb: 5,
            borderBottomWidth: 1,
            borderColor: "themeSectionSeparator",
            _ios: {
              py: 3
            },
            _android: {
              py: 3
            }
          };
        },
        joinWaitlist_EstimatedWaitTime_AvailableStatus_VStack: {
          _web: {
            px: 5,
            pt: {
              lg: 2,
              base: 4
            }
          },
          mb: 5,
          _ios: {
            mb: 2,
            p: 5
          },
          _android: {
            mb: 2,
            p: 5
          }
        },
        // JOIN WAITLIST END
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 10
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        }
      }
    },
    HStack: {
      variants: {
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 8
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        listItemBox: {
          borderRadius: 10
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref38) {
          var isSelected = _ref38.isSelected;
          return {
            bg: "#E5E5E5",
            borderWidth: isSelected ? 0 : 1,
            borderColor: "themeSectionSeparator",
            borderRadius: isSelected ? 0 : 13,
            shadow: 5,
            overflow: "hidden"
          };
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Outer_HStack: function joinWaitlist_StaticMap_Outer_HStack() {
          return {
            alignItems: "center",
            backgroundColor: "white",
            width: {
              md: "100%"
            }
          };
        },
        joinWaitlist_StaticMap_Inner_HStack: function joinWaitlist_StaticMap_Inner_HStack() {
          return {
            py: 4,
            pr: 4,
            flex: {
              md: 1
            },
            alignItems: "top",
            w: "100%",
            _ios: {
              alignItems: "flex-start"
            },
            _android: {
              alignItems: "flex-start"
            }
          };
        },
        joinWaitlist_StickyCTAButtons_Container: function joinWaitlist_StickyCTAButtons_Container() {
          return {
            bg: "white",
            py: 3,
            px: 4,
            space: 4,
            justifyContent: {
              lg: "flex-end"
            },
            _ios: {
              shadow: 15
            },
            _web: {
              shadow: 15
            }
          };
        },
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#D6D6D6"
          };
        },
        // JOIN WAITLIST END
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        //Location Search
        locationSearchSearchThisArea: {
          position: "absolute",
          top: {
            base: 4,
            md: 8
          },
          left: 0,
          alignItems: "center",
          width: "100%"
        },
        borderRadiusValue: function borderRadiusValue(_ref39) {
          var radiusValue = _ref39.radiusValue,
              topRadiusValue = _ref39.topRadiusValue,
              bottomRadiusValue = _ref39.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        menuDetailArrowPosition: {
          mt: 0
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },
        // My Account
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 8,
          borderColor: "#DCDCDC",
          borderWidth: 1,
          shadow: 17
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 3
          },
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F6F6F6"
          },
          borderRadius: 8,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        // My Account
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "white",
          zIndex: 1
        },
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "background.100",
          alignItems: "center",
          mb: 2
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          }
        }
      }
    },
    Image: {
      variants: {
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        breadSticksBannerImage: {
          w: "66px",
          h: "66px"
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          borderRadius: 10,
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "15px",
          width: "15px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 6,
            height: 8
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref40) {
          var radiusValue = _ref40.radiusValue,
              topRadiusValue = _ref40.topRadiusValue,
              bottomRadiusValue = _ref40.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref41) {
          var active = _ref41.active;
          return {
            height: active ? 8 : 6,
            width: active ? 8 : 6,
            _web: {
              bottom: "2px"
            }
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        }
      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },
        breadSticksBannerImageBox: {
          position: "absolute",
          top: -5,
          left: 3,
          zIndex: 1
        },
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "og_brothermedium"
        },
        remoteCheckinWaitTimeParentBox: {
          bg: "#F3F4EA"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: {
            base: 5,
            md: 9
          },
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        OrderInfoBannerCartIconBox: {
          pb: 1
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 6,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref42) {
          var hasSub = _ref42.hasSub;
          return {
            mb: {
              base: hasSub && -1,
              md: hasSub && -4
            }
          };
        },
        configOptionBox: {
          borderRadius: 12
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 12,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        headerCaretIcon: function headerCaretIcon() {
          return {
            mb: 1
          };
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 1.5
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: "og_brotherlight",
            color: "#2A2C25",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "393px",
                md: "413px"
              },
              pb: 10
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref43) {
          var isChild = _ref43.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 10,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 10
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 8,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: {
          borderBottomWidth: 1,
          borderWidth: {
            base: 0,
            md: 1
          },
          borderColor: "allLocationsItemBoxBorderColor",
          borderRadius: {
            base: 0,
            md: 8
          },
          p: {
            base: 0,
            md: 1
          },
          mt: {
            base: 0,
            md: 4
          },
          mr: {
            base: 0,
            md: 8
          },
          _web: {
            minWidth: {
              base: "100%",
              md: "300px"
            }
          },
          width: "40%",
          bg: "#ffffff"
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        //MenuSearch
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref44) {
          var isMobile = _ref44.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref45) {
          var hideWaitlistSection = _ref45.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          _web: {
            maxWidth: "450px"
          },
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref46) {
          var isSticky = _ref46.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref47) {
          var isMobile = _ref47.isMobile,
              singleActionButton = _ref47.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": isMobile && !singleActionButton ? " 1fr 1fr" : "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#532A43"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref48) {
          var isInStack = _ref48.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          borderRadius: 15,
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          borderRadius: 15,
          shadow: 11,
          mr: "8"
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Restaurant Details end
        // JOIN WAITLIST START
        joinWaitlist_StaticMap_Box: function joinWaitlist_StaticMap_Box() {
          return {
            position: "relative",
            overflow: "hidden",
            height: {
              base: 101,
              md: "100%"
            },
            w: {
              md: 230,
              lg: 170,
              xl: 230
            }
          };
        },
        joinWaitlist_StaticMap_Icon_Container: function joinWaitlist_StaticMap_Icon_Container() {
          return {
            pl: {
              lg: 5,
              base: 3
            },
            pr: {
              lg: 3,
              base: 2
            },
            mt: {
              lg: -1,
              base: -0.5
            }
          };
        },
        joinWaitlist_Form_Container: function joinWaitlist_Form_Container() {
          return {
            bg: "white",
            rounded: 12,
            p: 5,
            mx: 5,
            shadow: {
              base: 10,
              lg: "none"
            }
          };
        },
        joinWaitlist_Form_Filled_Container: function joinWaitlist_Form_Filled_Container() {
          return {
            bg: "white",
            rounded: 12,
            py: 5,
            px: 4,
            mx: 5,
            shadow: 10
          };
        },
        // JOIN WAITLIST END
        //Location search
        tabLocationsTopWidth: 0,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref49) {
          var isActive = _ref49.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref50) {
          var radiusValue = _ref50.radiusValue,
              topRadiusValue = _ref50.topRadiusValue,
              bottomRadiusValue = _ref50.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        remoteCheckinContainer: {
          px: 6,
          py: 4,
          _web: {
            borderRadius: "12px"
          },
          borderWidth: 1,
          borderColor: "#F4F4F4",
          borderRadius: 3,
          width: {
            base: "100%",
            md: "335px"
          },
          shadow: 13,
          justifyContent: "space-around",
          alignItems: "center"
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref51) {
          var isSmallScreen = _ref51.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            mx: 5,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref52) {
          var isIOS = _ref52.isIOS;
          return {
            _text: {
              color: "white",
              pt: isIOS ? 1 : 0,
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 35,
          width: 28
        },
        // My Account
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 750,
          overflow: "clip",
          rounded: 12,
          bg: "white",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#EDEDED"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#EDEDED",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: "white",
          mt: 1
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 16,
          overflow: "hidden"
        },
        myAccount_paymentOptions_container: {
          paddingBottom: 5,
          backgroundColor: "#F6F6F6",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%",
            bg: {
              base: "myAccountScreenBackroundColor",
              md: "white"
            }
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#54301A",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 12,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "#F3F4E7",
          borderBottomWidth: 1,
          borderColor: "paymentOptionsBorderColor",
          _web: {
            marginX: {
              base: 0,
              md: 5
            },
            backgroundColor: "paymentOptionsHeaderColor"
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          py: 0.5,
          px: 3,
          _web: {
            py: 1
          }
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "60%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          py: 4,
          w: "100%"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between",
          pt: {
            base: 3,
            md: 6
          }
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#F6F6F6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: {
            base: 5,
            md: 12
          },
          alignItems: "flex-start",
          justifyContent: "center",
          mb: 5
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "white",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            pb: 4,
            pt: 2
          },
          _ios: {
            pb: 4,
            pt: 2
          },
          paddingX: 5,
          alignItems: "center",
          bg: {
            base: "#F6F6F6",
            md: "white"
          },
          _web: {
            py: {
              base: 5,
              md: 3.5
            },
            paddingX: {
              base: 5,
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 4,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        // My Account ends
        eClub_Building_Box: {
          w: "100%",
          h: 800,
          bg: "background.100"
        },
        eClubSignUpBox: {
          borderRadius: 20,
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          borderRadius: 20,
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        smartRecommendationModalHeadingContainer: {
          flex: 1
        },
        myAccount_editFields_actionSheet_webBox: {
          pt: 2,
          pb: 7
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#F6F7F0",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#EAEAEA",
          accessible: false,
          _web: {
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref53) {
          var radiusValue = _ref53.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(91.85deg, #9A4B32 0%, #BA773E 100%)"
              }
            },
            borderRadius: radiusValue,
            borderTopRadius: radiusValue,
            borderBottomRadius: radiusValue,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "#FFFFFF",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: "transparent"
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 3,
          paddingBottom: 4,
          justifyContent: "center"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          }
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 59,
          width: 83,
          _web: {
            height: "60px",
            width: "82px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4,
          _android: {
            bgColor: "editProfileScreensBackgroundColor"
          },
          _ios: {
            bgColor: "editProfileScreensBackgroundColor"
          }
        },
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        eClubBGGradient_box: {
          position: "absolute",
          bottom: 0,
          w: "100%",
          h: "30%",
          _web: {
            style: {
              background: "linear-gradient(to bottom, rgb(242, 244, 234, 0) 0%, rgb(242, 244, 234, 1) 100%)"
            }
          }
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 12
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref54) {
          var radiusValue = _ref54.radiusValue,
              topRadiusValue = _ref54.topRadiusValue,
              bottomRadiusValue = _ref54.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 16,
          backgroundColor: "white",
          shadow: 4
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          marginRight: 5
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref55) {
          var isMobile = _ref55.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: {
              base: 0,
              md: 12
            },
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#F8F7F6",
          rounded: 12,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref56) {
          var radiusValue = _ref56.radiusValue,
              topRadiusValue = _ref56.topRadiusValue,
              bottomRadiusValue = _ref56.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref57) {
          var radiusValue = _ref57.radiusValue,
              topRadiusValue = _ref57.topRadiusValue,
              bottomRadiusValue = _ref57.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "white"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0,
          bg: "#FFFFFF"
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref58) {
          var radiusValue = _ref58.radiusValue;
          return {
            borderRadius: radiusValue
          };
        }
      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref59) {
          var radiusValue = _ref59.radiusValue,
              topRadiusValue = _ref59.topRadiusValue,
              bottomRadiusValue = _ref59.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%"
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 3.5,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 4,
              md: 3
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    }
  },
  fontConfig: {
    OGBrother: {
      100: {
        normal: "og_brotherlight",
        italic: "og_brotherlight"
      },
      200: {
        normal: "og_brotherlight",
        italic: "og_brotherlight"
      },
      300: {
        normal: "og_brotherregular",
        italic: "og_brotherregular"
      },
      400: {
        normal: "og_brothermedium",
        italic: "og_brothermedium"
      },
      500: {
        normal: "og_brotherextrabold",
        italic: "og_brotherextrabold"
      },
      600: {
        normal: "og_brotherextrabold",
        italic: "og_brotherextrabold"
      },
      700: {
        normal: "og_brotherextrabold",
        italic: "og_brotherextrabold"
      },
      800: {
        normal: "og_brotherextrabold",
        italic: "og_brotherextrabold"
      },
      900: {
        normal: "og_brotherextrabold",
        italic: "og_brotherextrabold"
      }
    }
  },
  fonts: {
    heading: "OGBrother",
    body: "OGBrother",
    headingSecondary: "OGBrother",
    youMightLikeText: "og_brotherextrabold"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));